import React from 'react';
import { IMPORT_SUMMARY_ROWS } from '../../consts/consts';
import { LoadingIndicator } from '../ui';
import {
  ImportLoadingStateWrapper,
  ImportSummaryRow,
  ImportSummaryIcon,
  ImportSummaryText,
  ImportSummaryHighlightedText
} from '../ui/Layout/ImportLayout';
import { IconCheck } from '../ui/Icons';
import { LoadingIndicatorLayout } from '../ui/Layout/LoadingIndicatorLayout';

const { LoadingSuccessContentWrapper } = LoadingIndicatorLayout;

/**
 * This component is used for displaing the loading states of the import process.
 * @param {boolean} isLoading - shows if the loading or the success state should be displayed
 * @param {boolean} isFileCheckLoadingState - flag to show if the first step of the import is loading or the second one.
 * @param {array} importSummary - this array contains the import summary entries, they have the structure of metadata objects.
 * @param {string} className - Optional class name for wrapper-specific layout adjustments.
 * @param {string} loadingIndicatorClassName - Optional class name for the inner loading indicator.
 */
export const ImportLoadingState = ({
  isLoading,
  isFileCheckLoadingState = false,
  importSummary,
  className,
  loadingIndicatorClassName
}) => {
  const renderImportSummaryRows = () => {
    if (!importSummary) {
      return null;
    }
    return IMPORT_SUMMARY_ROWS.map((summaryRow) => {
      const count = importSummary.find((entry) => entry.rel === summaryRow.key)?.count || 0;
      const entityName = count === 1 ? summaryRow.entityNameSingular : summaryRow.entityNamePlural;

      return (
        <ImportSummaryRow key={summaryRow.key}>
          <ImportSummaryIcon>
            <IconCheck />
          </ImportSummaryIcon>
          <ImportSummaryHighlightedText>{count}</ImportSummaryHighlightedText>
          <ImportSummaryText>
            {entityName} {summaryRow.operation}
          </ImportSummaryText>
        </ImportSummaryRow>
      );
    });
  };

  const loadingMessage = isFileCheckLoadingState
    ? 'Stammdaten werden hochgeladen.'
    : 'Stammdaten werden in Ihr Portal importiert.';

  const getSuccessMessage = () => {
    return (
      <LoadingSuccessContentWrapper>
        Import abgeschlossen
        <div>{renderImportSummaryRows()}</div>
      </LoadingSuccessContentWrapper>
    );
  };

  return (
    <ImportLoadingStateWrapper className={className}>
      <LoadingIndicator
        className={loadingIndicatorClassName}
        isLoading={isLoading}
        loadingMessage={loadingMessage}
        successMessage={getSuccessMessage()}
      />
    </ImportLoadingStateWrapper>
  );
};
